module.exports = "<div class=\"form-control-static\" ng-bind=\"firstCharData.value | currencyNumber | currency: (dcVM.currencySymbol + ' ')\"></div>"